export const isEdge = (): boolean => {
    return window.navigator.userAgent.indexOf("Edge") > -1;
}